import { FC } from 'react';
import { Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';
import { addHours } from 'date-fns';

import { useTimezone } from '../../../../hooks/useTimezone';

interface OffHoursModalProps {
  isOpen: boolean;
  anchorTime: Date | undefined;
  handleSave: () => void;
  handleClose: () => void;
}

export const OffHoursModal: FC<OffHoursModalProps> = ({ isOpen, anchorTime, handleClose, handleSave }) => {
  const { formatInTimezone } = useTimezone();

  const getOffHoursTitle = () => {
    const offHoursSuggestedTime = anchorTime ? formatInTimezone(addHours(anchorTime, 12), 'hh:mm a') : '';

    return `Did you mean ${offHoursSuggestedTime}?`;
  };

  const getOffHoursTime = () => {
    return formatInTimezone(anchorTime, 'hh:mm a');
  };

  return (
    <Modal open={isOpen} onClose={handleClose} data-testid="offhours-modal">
      <Modal.Title>{getOffHoursTitle()}</Modal.Title>
      <Modal.Content>
        <Text>The ride time you entered is at {getOffHoursTime()}. Did you mean to set that time?</Text>
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={handleClose}>
          No
        </Button>
        <Button autoFocus color="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
